module.exports = __webpack_public_path__ + "static/cucumber-f369185ee2c1e7db398b4d579be13205.png";